var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeeperLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60.000000pt",
    height: "52.000000pt",
    viewBox: "0 0 60.000000 52.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,52.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 490 c-79 -42 -119 -123 -98 -203 14 -59 142 -222 200 -256 57 -34 121 -34 178 0 58 34 186 197 200 256 21 81 -19 162 -100 203 -49 25 -99 25 -149 0 l-40 -20 -40 20 c-49 25 -104 25 -151 0z m141 -65 c16 -8 34 -23 40 -32 10 -17 10 -17 20 0 15 24 63 47 100 47 48 0 86 -25 103 -69 23 -55 11 -86 -73 -191 -79 -99 -110 -117 -174 -99 -27 7 -52 31 -106 99 -39 49 -75 103 -80 119 -28 98 76 175 170 126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 362 c-17 -6 -30 -22 -30 -37 0 -12 117 -157 136 -168 8 -4 20 -4 28 0 19 11 136 156 136 168 -1 25 -23 40 -55 36 -6 0 -28 -23 -49 -51 -21 -27 -42 -50 -46 -50 -4 0 -25 22 -46 50 -40 53 -50 60 -74 52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeeperLogo);
export default __webpack_public_path__ + "static/media/VeeperLogo.ae2a15096af867da1629327b6016ce26.svg";
export { ForwardRef as ReactComponent };